const ArrowRightIcon = () => {
	return (
		<svg
			width="10"
			height="20"
			viewBox="0 0 10 20"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path d="M0 20V0L10 10L0 20Z" fill="#000046" />
		</svg>
	);
};

export default ArrowRightIcon;